import { Controller } from '@hotwired/stimulus';
import { adobeTrack } from 'src/lib/adobe_track';

export default class extends Controller {
  onClickGetDirections() {
    adobeTrack('getDirections');
  }

  onClickCall() {
    adobeTrack('contactCall');
  }

  onClickFindStore() {
    adobeTrack('findStore');
  }

  onClickPrint(e) {
    e.preventDefault();

    window.print();
  }
}
